<!--
  a11y (ESP-18522): the cells render as static text EXCEPT the openable "name"
  cell, which opts in (rowOpenAction) to a real <button> — the single interactive
  control that redirects to the Plan Details page. Only this control is a Tab stop
  (tabindex=0); the remaining columns stay plain text so keyboard users are not
  forced through redundant / duplicate-action stops and reach them with the Arrow
  keys instead.

  a11y (ESP-18464 / Dragon): the button's accessible name is the visible value so
  voice control (Dragon) can click it by name. An explicit aria-label (the full,
  untruncated value) is set so Dragon targets the whole plan name even when the
  visible text is shortened by text-overflow: ellipsis (ESP-18529).
-->
<button *ngIf="isOpenAction; else staticText"
        type="button"
        class="cell-link-button"
        tabindex="0"
        [attr.aria-label]="content"
        placement="right" pTooltip="{{content}}" tooltipPosition="right" showDelay="250"
        (click)="onActivate($event)">
  {{content}}
</button>
<ng-template #staticText>
  <span placement="right" pTooltip="{{content}}" tooltipPosition="right" showDelay="250">
    {{content}}
  </span>
</ng-template>
